var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconEventTimeLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41699 5.49967C5.41699 5.9417 5.59259 6.36563 5.90515 6.67819C6.21771 6.99075 6.64163 7.16634 7.08366 7.16634C7.52569 7.16634 7.94961 6.99075 8.26217 6.67819C8.57473 6.36563 8.75033 5.9417 8.75033 5.49967C8.75033 5.05765 8.57473 4.63372 8.26217 4.32116C7.94961 4.0086 7.52569 3.83301 7.08366 3.83301C6.64163 3.83301 6.21771 4.0086 5.90515 4.32116C5.59259 4.63372 5.41699 5.05765 5.41699 5.49967ZM12.917 10.4997C12.917 10.9417 13.0926 11.3656 13.4051 11.6782C13.7177 11.9907 14.1416 12.1663 14.5837 12.1663C15.0257 12.1663 15.4496 11.9907 15.7622 11.6782C16.0747 11.3656 16.2503 10.9417 16.2503 10.4997C16.2503 10.0576 16.0747 9.63372 15.7622 9.32116C15.4496 9.0086 15.0257 8.83301 14.5837 8.83301C14.1416 8.83301 13.7177 9.0086 13.4051 9.32116C13.0926 9.63372 12.917 10.0576 12.917 10.4997ZM5.41699 15.4997C5.41699 15.9417 5.59259 16.3656 5.90515 16.6782C6.21771 16.9907 6.64163 17.1663 7.08366 17.1663C7.52569 17.1663 7.94961 16.9907 8.26217 16.6782C8.57473 16.3656 8.75033 15.9417 8.75033 15.4997C8.75033 15.0576 8.57473 14.6337 8.26217 14.3212C7.94961 14.0086 7.52569 13.833 7.08366 13.833C6.64163 13.833 6.21771 14.0086 5.90515 14.3212C5.59259 14.6337 5.41699 15.0576 5.41699 15.4997Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 15.5H5.41699M8.75033 15.5H18.3337M1.66699 5.5H5.41699M8.75033 5.5H18.3337",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 2.1665V18.8332",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.5H12.917M16.2503 10.5H18.3337",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEventTimeLine);
export default __webpack_public_path__ + "static/media/common_icon_event_time_line.6c307345fc944165ec45bff4353df33f.svg";
export { ForwardRef as ReactComponent };